module.exports = __webpack_public_path__ + "static/media/screenshotes-480w.a48a749e.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Projects/MU/assets/screenshotes-480w.png
// module id = 193
// module chunks = 0